import { defineStore } from "pinia";
import { ref } from "vue";
import { getAnnotationById, saveAnnotation } from "@/services/api/annotation.js";
import { getUser } from "@/services/api/auth.js";

export const favoritesStore = defineStore("favorites", () => {
    const favoriteCards = ref([]);

    function normalizeFavorites(list) {
        return list.map((item, index) => ({
            icon: item.icon || "mdi-star",
            order: item.order ?? index,
            ...item
        }));
    }

    async function loadFavorites() {
        const user = getUser();
        const stars = await getAnnotationById({ id: `favorite-${user.id}-corp-${user.corpId}` });

        if (!stars?.content) {
            favoriteCards.value = [];
            return;
        }

        const raw = stars.content.trim();
        const parsed = raw.startsWith("[")
            ? JSON.parse(raw)
            : JSON.parse("[" + raw + "]");

        favoriteCards.value = normalizeFavorites(parsed);
    }

    async function persistFavorites() {
        const user = getUser();
        await saveAnnotation({
            id: `favorite-${user.id}-corp-${user.corpId}`,
            content: JSON.stringify(favoriteCards.value),
        });
    }

    async function toggleFavorite(card) {
        const exists = favoriteCards.value.find(
            f => f.title === card.title
        );

        if (exists) {
            favoriteCards.value = favoriteCards.value.filter(
                f => f.title !== card.title
            );
        } else {
            favoriteCards.value.push({
                ...card,
                icon: "mdi-star",
                order: favoriteCards.value.length
            });
        }

        await persistFavorites();
    }

    async function updateOrder(newOrder) {
        favoriteCards.value = newOrder.map((item, index) => ({
            ...item,
            order: index
        }));

        await persistFavorites();
    }

    async function updateIcon(title, icon) {
        const fav = favoriteCards.value.find(f => f.title === title);
        if (!fav) return;

        fav.icon = icon;
        await persistFavorites();
    }

    return {
        favoriteCards,
        loadFavorites,
        toggleFavorite,
        updateOrder,
        updateIcon
    };
});
